<template>
  <div class="demo">
    <input
      type="radio"
      :value="value"
      :name="name"
      @change="emitVal"
      :checked="propVal===value"
    />
    <label>{{ label }}</label>
  </div>
</template>

<script>
export default {
  model: {
    prop: "propVal",
    event: "change"
  },
  props: {
    value: [String, Boolean, Number, Object],
    name: String,
    label: String,
    propVal: [String, Boolean, Number, Object]
  },
  methods: {
    emitVal(event) {
      this.$emit('change', event.target.value)
    }
  }
};
</script>